import { queryOptions } from '@tanstack/react-query';
import { attentionQueryRoot } from '../../../../shared/api/index.js';
import { getAttention } from '../requests/get-attention.js';

export const attentionQueries = {
  ...attentionQueryRoot,
  list: () =>
    queryOptions({
      queryKey: [...attentionQueryRoot.all(), 'list'] as const,
      queryFn: ({ signal }) => getAttention(signal),
      staleTime: 0,
    }),
};
